'use client'

import { memo } from 'react'
import Link from 'next/link'
import { Ninxl8BitThemeToggle } from '@/app/(marketing)/_components/8bit'
import { NinSocialIconLinks } from '@/app/(marketing)/_components/nin-social-icon-links'
import { NIN_BLOGS_URL, NIN_LEARN_URL } from './nin-org-links'

export const NinOrgFooter = memo(function NinOrgFooter() {
  return (
    <footer className="ninxl-theme-border-soft border-t-2 py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-y-4 px-6 md:flex-row md:px-8">
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
          <Link
            href={NIN_LEARN_URL}
            className="ninxl-8bit-label ninxl-theme-link"
          >
            Learn
          </Link>
          <Link
            href={NIN_BLOGS_URL}
            className="ninxl-8bit-label ninxl-theme-link"
          >
            Blogs
          </Link>
          <Link
            href="/ningenie/policies/terms-of-service"
            className="ninxl-8bit-label ninxl-theme-link"
          >
            Terms
          </Link>
          <Link
            href="/ningenie/policies/privacy-policy"
            className="ninxl-8bit-label ninxl-theme-link"
          >
            Privacy
          </Link>
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-4">
          <NinSocialIconLinks />
          <Ninxl8BitThemeToggle />
          <div className="ninxl-8bit-label">© 2026 NIN. All rights reserved.</div>
        </div>
      </div>
    </footer>
  )
})
